module.exports = __webpack_public_path__ + "static/icons-nocolor-8f6e4259230aefca3644ce920deaf88e.svg";